export default __webpack_public_path__ + "static/media/action-items.19360e64.png";